var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.04492C6.72886 2.04492 0 7.85606 0 14.9995C0 15.4181 0.0231818 15.8395 0.0695455 16.2513C0.141818 16.9031 0.501818 17.4711 1.0575 17.8086C1.59273 18.1345 2.23364 18.1924 2.81523 17.9688C3.16636 17.8338 3.34159 17.439 3.20727 17.0879C3.07159 16.7361 2.67682 16.5608 2.32636 16.6958C2.07409 16.7927 1.8675 16.7047 1.76659 16.6433C1.575 16.5267 1.45091 16.329 1.425 16.0999C1.38409 15.7379 1.36364 15.3676 1.36364 14.9995C1.36364 8.6081 7.48091 3.40856 15 3.40856C22.5191 3.40856 28.6364 8.6081 28.6364 14.9995C28.6364 21.3908 22.5191 26.5904 15 26.5904C14.203 26.5904 13.4025 26.5311 12.6218 26.4138C12.4077 26.3817 12.2202 26.2611 12.1077 26.0831C12.0505 25.9931 11.9652 25.8063 12.0348 25.5751C12.238 24.9015 12.3416 24.2013 12.3416 23.4956C12.3416 19.6856 9.3375 16.4913 5.50227 16.2233C5.12318 16.1967 4.80068 16.4804 4.77477 16.8561C4.74818 17.2317 5.03182 17.5576 5.4075 17.5836C8.53159 17.8017 10.978 20.3981 10.978 23.4949C10.978 24.067 10.8941 24.6342 10.7291 25.1804C10.5634 25.7286 10.6466 26.3231 10.9561 26.812C11.2807 27.3247 11.8145 27.6711 12.42 27.7617C13.2668 27.8892 14.1348 27.954 15 27.954C23.2711 27.954 30 22.1429 30 14.9995C30 7.85606 23.2711 2.04492 15 2.04492Z",
    fill: "url(#paint0_linear_2146_13182)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 5.45312C12.5087 5.45312 11.5909 6.37085 11.5909 7.49858C11.5909 8.62631 12.5087 9.54403 13.6364 9.54403C14.7641 9.54403 15.6819 8.62631 15.6819 7.49858C15.6819 6.37085 14.7641 5.45312 13.6364 5.45312ZM13.6364 8.1804C13.2607 8.1804 12.9546 7.87426 12.9546 7.49858C12.9546 7.1229 13.2607 6.81676 13.6364 6.81676C14.0121 6.81676 14.3182 7.1229 14.3182 7.49858C14.3182 7.87426 14.0121 8.1804 13.6364 8.1804Z",
    fill: "url(#paint1_linear_2146_13182)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 6.81836C20.0087 6.81836 19.0909 7.73609 19.0909 8.86381C19.0909 9.99154 20.0087 10.9093 21.1364 10.9093C22.2641 10.9093 23.1819 9.99154 23.1819 8.86381C23.1819 7.73609 22.2641 6.81836 21.1364 6.81836ZM21.1364 9.54563C20.7607 9.54563 20.4546 9.2395 20.4546 8.86381C20.4546 8.48813 20.7607 8.182 21.1364 8.182C21.5121 8.182 21.8182 8.48813 21.8182 8.86381C21.8182 9.2395 21.5121 9.54563 21.1364 9.54563Z",
    fill: "url(#paint2_linear_2146_13182)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5455 17.044C25.6732 17.044 26.5909 16.1263 26.5909 14.9986C26.5909 13.8709 25.6732 12.9531 24.5455 12.9531C23.4177 12.9531 22.5 13.8709 22.5 14.9986C22.5 16.1263 23.4177 17.044 24.5455 17.044ZM24.5455 14.3168C24.9211 14.3168 25.2273 14.6229 25.2273 14.9986C25.2273 15.3743 24.9211 15.6804 24.5455 15.6804C24.1698 15.6804 23.8636 15.3743 23.8636 14.9986C23.8636 14.6229 24.1698 14.3168 24.5455 14.3168Z",
    fill: "url(#paint3_linear_2146_13182)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.1355C15 22.6396 16.2232 23.8627 17.7273 23.8627C19.2314 23.8627 20.4545 22.6396 20.4545 21.1355C20.4545 19.6314 19.2314 18.4082 17.7273 18.4082C16.2232 18.4082 15 19.6314 15 21.1355ZM19.0909 21.1355C19.0909 21.8875 18.4793 22.4991 17.7273 22.4991C16.9752 22.4991 16.3636 21.8875 16.3636 21.1355C16.3636 20.3834 16.9752 19.7718 17.7273 19.7718C18.4793 19.7718 19.0909 20.3834 19.0909 21.1355Z",
    fill: "url(#paint4_linear_2146_13182)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 12.9542C8.62777 12.9542 9.5455 12.0365 9.5455 10.9087C9.5455 9.78101 8.62777 8.86328 7.50004 8.86328C6.37232 8.86328 5.45459 9.78101 5.45459 10.9087C5.45459 12.0365 6.37232 12.9542 7.50004 12.9542ZM7.50004 10.2269C7.87573 10.2269 8.18186 10.5331 8.18186 10.9087C8.18186 11.2844 7.87573 11.5906 7.50004 11.5906C7.12436 11.5906 6.81823 11.2844 6.81823 10.9087C6.81823 10.5331 7.12436 10.2269 7.50004 10.2269Z",
    fill: "url(#paint5_linear_2146_13182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13182",
    x1: 15,
    y1: 2.04492,
    x2: 15,
    y2: 27.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13182",
    x1: 13.6364,
    y1: 5.45312,
    x2: 13.6364,
    y2: 9.54403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13182",
    x1: 21.1364,
    y1: 6.81836,
    x2: 21.1364,
    y2: 10.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13182",
    x1: 24.5455,
    y1: 12.9531,
    x2: 24.5455,
    y2: 17.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2146_13182",
    x1: 17.7273,
    y1: 18.4082,
    x2: 17.7273,
    y2: 23.8627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2146_13182",
    x1: 7.50004,
    y1: 8.86328,
    x2: 7.50004,
    y2: 12.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.2d47c0d7.svg";
export { ForwardRef as ReactComponent };